var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVerified = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#523DF1",
    d: "M9.668.18a.397.397 0 0 1 .664 0l1.022 1.56a.397.397 0 0 0 .556.11L13.451.8a.397.397 0 0 1 .614.254l.347 1.833c.041.218.254.36.471.315l1.826-.381c.28-.059.529.19.47.47l-.381 1.826a.397.397 0 0 0 .315.471l1.833.347a.397.397 0 0 1 .254.614l-1.05 1.54a.397.397 0 0 0 .11.557l1.56 1.022c.24.156.24.508 0 .664l-1.56 1.022a.397.397 0 0 0-.11.556l1.05 1.541a.397.397 0 0 1-.254.614l-1.833.347a.397.397 0 0 0-.315.471l.381 1.826a.397.397 0 0 1-.47.47l-1.826-.381a.397.397 0 0 0-.471.315l-.347 1.833a.397.397 0 0 1-.614.254l-1.54-1.05a.397.397 0 0 0-.557.11l-1.022 1.56a.397.397 0 0 1-.664 0l-1.022-1.56a.397.397 0 0 0-.556-.11L6.549 19.2a.397.397 0 0 1-.614-.254l-.347-1.833a.397.397 0 0 0-.471-.315l-1.826.381a.397.397 0 0 1-.47-.47l.381-1.826a.397.397 0 0 0-.315-.471l-1.833-.347a.397.397 0 0 1-.254-.614l1.05-1.54a.397.397 0 0 0-.11-.557L.18 10.332a.397.397 0 0 1 0-.664l1.56-1.022a.397.397 0 0 0 .11-.556L.8 6.549a.397.397 0 0 1 .254-.614l1.833-.347a.397.397 0 0 0 .315-.471L2.821 3.29a.397.397 0 0 1 .47-.47l1.826.381a.397.397 0 0 0 .471-.315l.347-1.833A.397.397 0 0 1 6.549.8l1.54 1.05a.397.397 0 0 0 .557-.11L9.668.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.5 9.5 2.301 2.688L13.5 7.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVerified);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/verified.b1c0c06d3a86a984838af327ed9779a2.svg";